import { useContext } from 'react';
import { SessionContext } from './SessionContext';

export const useSession = () => {
  const session = useContext(SessionContext);
  return session;
};
